import React from 'react';
import { motion } from 'framer-motion';
import type { OfferItem } from '../types/offer';
interface EvidencePlateProps {
  item: OfferItem;
  index: number;
}
export function EvidencePlate({
  item,
  index
}: EvidencePlateProps) {
  const tilt = index % 2 === 0 ? -0.8 : 0.8;
  return <motion.article initial={{
    opacity: 0,
    y: 34,
    rotate: tilt * 3
  }} whileInView={{
    opacity: 1,
    y: 0,
    rotate: tilt
  }} whileHover={{
    rotate: 0,
    y: -6
  }} viewport={{
    once: true,
    amount: 0.3
  }} transition={{
    duration: 0.6,
    delay: index * 0.07
  }} className="group relative rounded-xl border border-gold/20 bg-panel-raised p-3 pb-4 shadow-[0_14px_30px_rgba(0,0,0,0.55)]" data-id="element-83" data-mp="3ebhouea07h91">
      <span aria-hidden="true" className="absolute -top-2 left-1/2 z-20 h-3 w-6 -translate-x-1/2 rotate-3 rounded-[3px] border border-white/25 bg-[linear-gradient(135deg,#cfcfd4,#8b8b92)]" data-id="element-84" data-mp="14poipvh6pjz" />
      <span className="absolute right-2.5 top-2.5 z-20 rounded border border-signal-pink/60 bg-ink/60 px-1.5 py-0.5 font-mono text-[8px] font-extrabold tracking-[0.06em] text-signal-pink" data-id="element-85" data-mp="tls8fwtnjne8">
        EVD·{String(index + 1).padStart(2, '0')}
      </span>

      <div className="relative rounded-md bg-white p-1.5" data-id="element-86" data-mp="15oq7gkzfgxcr">
        <div className="flex aspect-[3/4] w-full items-center justify-center overflow-hidden rounded-sm bg-white" data-id="element-87" data-mp="1kgh66rb3crf8">
          <img src={item.image} alt={item.alt} loading="lazy" decoding="async" sizes="(min-width: 1280px) 22rem, (min-width: 640px) 45vw, 90vw" className="h-full w-full object-contain" data-id="element-88" data-mp="1fnecmj6bdhz1" />
        </div>
      </div>

      <span className="mt-3 block font-mono text-[9px] uppercase tracking-[0.16em] text-gold-dim sm:mt-4" data-id="element-89" data-mp="23e1kj4g8c7ll">
        {item.kicker}
      </span>
      <h3 className="mt-1.5 font-display text-[1.05rem] font-bold leading-snug text-bone" data-id="element-90" data-mp="90isga4yxh7o">
        {item.title}
      </h3>
      <p className="mt-2 text-[12.5px] leading-relaxed text-ash" data-id="element-91" data-mp="41z7aby789gd">
        {item.description}
      </p>
      <span className={`mt-3 inline-block rounded-full border px-3 py-1 font-mono text-[10px] font-extrabold sm:mt-4 ${item.isFree ? 'border-signal-cyan/40 text-[#8be3ff]' : 'border-gold/30 text-gold'}`} data-id="element-92" data-mp="244gsln1lz98e">
        {item.isFree ? 'GRATIS' : `Valor: ${item.value}`}
      </span>
    </motion.article>;
}